// Nepali / English copy for the Add Bell schedule modal. Kept in one place so the
// language toggle in the header only flips this table.
export const T = {
    ne: {
        title: "बेल तालिका बनाउनुहोस्",
        sub: "समय हाल्नुहोस् — तल दिनको नक्सामा तुरुन्तै देखिन्छ।",
        dayMap: "आजको दिन",
        dayHint: "बेलमा क्लिक गर्नुहोस् — आवाज सुनिन्छ।",
        ribbonEmpty: "अहिलेसम्म कुनै बेल थपिएको छैन",
        lgBell: "घण्टी",
        lgSoft: "मधुर धुन",
        lgInfo: "सूचना टोन",
        lgAlert: "सायरन",
        qfTitle: "एकैचोटि सबै पिरियड बनाउनुहोस्",
        qfSub: "सुरुको समय र पिरियडको लम्बाइ भन्नुहोस् — बाँकी हामी भर्छौं।",
        qfStart: "पहिलो पिरियड सुरु",
        qfLen: "पिरियड (मिनेट)",
        qfCount: "कति पिरियड",
        qfAfter: "खाजा कुन पिरियडपछि",
        qfBreak: "खाजा (मिनेट)",
        qfGo: "तालिका भर्नुहोस्",
        listTitle: "बेलहरू",
        cName: "बेलको नाम",
        cTime: "समय",
        cMusic: "संगीत",
        cDur: "बजाउने समय",
        addRow: "अर्को बेल थप्नुहोस्",
        hint: "सुझाव: नाम वा समयमा Enter थिच्दा अर्को पङ्क्ति आफैँ बन्छ।",
        cancel: "रद्द गर्नुहोस्",
        previewDay: "पूरा दिन सुन्नुहोस्",
        stopAll: "रोक्नुहोस्",
        save: "तालिका सुरक्षित गर्नुहोस्",
        namePh: "जस्तै, पहिलो पिरियड",
        sec: "से.",
        durLbl: "बजाउने समय (सेकेन्ड)",
        emptyT: "तालिका खाली छ",
        emptyS: "माथिको ⚡ बाट एकैचोटि सबै पिरियड बनाउनुहोस्, वा तल एउटा बेल थप्नुहोस्।",
        clash: "अघिल्लो बेलसँग एक मिनेटभित्र बज्दैछ — समय मिलाउनुहोस्।",
        sumA: "बेल",
        sumB: "पहिलो",
        sumC: "अन्तिम",
        countU: "बेल",
        saved: "तालिका सुरक्षित भयो",
        noTime: "सबै बेलको समय राख्नुहोस्",
        noMusic: "सबै बेलको संगीत छान्नुहोस्",
        listen: "सुन्नुहोस्",
        stop: "रोक्नुहोस्",
        pickMusic: "संगीत चयन गर्नुहोस्",
        loadingMusic: "संगीत लोड हुँदैछ…",
        presets: { p: "पिरियड", lunch: "खाजा", assembly: "प्रार्थना सभा", dismiss: "छुट्टी" },
    },
    en: {
        title: "Build your bell schedule",
        sub: "Enter a time — it appears on the day map below instantly.",
        dayMap: "The school day",
        dayHint: "Tap any bell to hear it.",
        ribbonEmpty: "No bells added yet",
        lgBell: "Bell",
        lgSoft: "Soft tune",
        lgInfo: "Notice tone",
        lgAlert: "Siren",
        qfTitle: "Create every period at once",
        qfSub: "Give us the start time and period length — we fill in the rest.",
        qfStart: "First period starts",
        qfLen: "Period (minutes)",
        qfCount: "How many periods",
        qfAfter: "Lunch after period",
        qfBreak: "Lunch (minutes)",
        qfGo: "Fill the schedule",
        listTitle: "Bells",
        cName: "Bell name",
        cTime: "Time",
        cMusic: "Music",
        cDur: "Play time",
        addRow: "Add another bell",
        hint: "Tip: press Enter in the name or time field to start the next row.",
        cancel: "Cancel",
        previewDay: "Hear the whole day",
        stopAll: "Stop",
        save: "Save schedule",
        namePh: "e.g. First period",
        sec: "sec",
        durLbl: "Play time (seconds)",
        emptyT: "Nothing scheduled yet",
        emptyS: "Use ⚡ above to build every period at once, or add a single bell below.",
        clash: "Rings within a minute of the bell before it — adjust the time.",
        sumA: "bells",
        sumB: "first",
        sumC: "last",
        countU: "bells",
        saved: "Schedule saved",
        noTime: "Every bell needs a time",
        noMusic: "Every bell needs music",
        listen: "Listen",
        stop: "Stop",
        pickMusic: "Choose music",
        loadingMusic: "Loading music…",
        presets: { p: "Period", lunch: "Lunch", assembly: "Assembly", dismiss: "Dismissal" },
    },
};
